import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
  wrongCode,
  connexion,
  resetAuthState,
  expired
} from '../store/actions/authActions';
import { titleColor } from '../tools/colors';
import { generateUUID, getIp } from '../tools/fonctions';

import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/fbConfig';

const Validation = () => {
  const [codeIns, setCodeIns] = useState('');

  const authSuccess = useSelector(state => state.auth.authSuccess);
  const authError = useSelector(state => state.auth.authError);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetAuthState());

    window.localStorage.setItem('UUID', generateUUID());
    getIp();

    if (!window.localStorage.email) {
      navigate('/authentification');
    }
  }, [dispatch, navigate]);

  const handleChange = (e) => {
    setCodeIns(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const todaysTimestamp = Date.now();

    try {
      const guidQuery = query(
        collection(db, 'GUID'),
        where('email', '==', window.localStorage.email)
      );

      const snapshot = await getDocs(guidQuery);

      snapshot.forEach(docSnap => {
        const data = docSnap.data();

        if (codeIns !== data.code) {
          dispatch(wrongCode());
        } else if (todaysTimestamp > data.lifetime) {
          dispatch(expired());
        } else {
          window.localStorage.setItem('validationStatus', 'true');
          dispatch(connexion(
            window.localStorage.email,
            window.localStorage.numTel
          ));
        }
      });
    } catch (error) {
      console.error('Erreur validation:', error);
      dispatch(wrongCode());
    }
  };

  return (
    <div className="validation">
      <div
        className="container"
        style={{
          border: '1px solid',
          borderColor: titleColor,
          position: 'relative',
          top: '50px',
          backgroundColor: 'white'
        }}
      >
        <form onSubmit={handleSubmit}>
          <h1 style={{ color: titleColor }}>Code de validation</h1>

          <div className="form-group">
            <label htmlFor="codeIns" className="h4">Code</label>
            <input
              type="text"
              className="form-control"
              id="codeIns"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <Link to="/authentification" className="btn btn-danger">
              Retour
            </Link>
            <button className="btn btn-primary ml-1">Valider</button>

            <div className="text-success">
              {authSuccess && <p>{authSuccess}</p>}
            </div>

            <div className="text-danger">
              {authError && <p>{authError}</p>}
            </div>

            <div className="text">
              {!authError && !authSuccess && (
                <em>
                  Un code de validation vous a été envoyé par mail, cela peut
                  prendre quelques minutes...
                </em>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Validation;
